import type { components } from '../../api/schema'

type AgentRunProposalCounts = components['schemas']['AgentRunProposalCounts']

export const PROPOSAL_BUCKETS = ['structure', 'documents', 'data', 'contracts', 'interventions'] as const
export type ProposalBucket = (typeof PROPOSAL_BUCKETS)[number]

const BUCKET_KINDS: Record<ProposalBucket, readonly (keyof AgentRunProposalCounts)[]> = {
    structure: ['asset', 'asset_relation', 'plan_proposal'],
    documents: ['document_link'],
    data: ['asset_data', 'contract_data', 'contract_value'],
    contracts: ['contract', 'contract_asset', 'contact'],
    interventions: ['intervention'],
}

/** proposalBuckets groups the eleven proposal kinds into the banner's five buckets, non-zero ones only. */
export function proposalBuckets(counts: AgentRunProposalCounts): { bucket: ProposalBucket; count: number }[] {
    return PROPOSAL_BUCKETS.map((bucket) => ({
        bucket,
        count: BUCKET_KINDS[bucket].reduce((sum, kind) => sum + counts[kind], 0),
    })).filter((b) => b.count > 0)
}
